<template>
  <div>
    <div v-if="$store.state.isReady">
      <topbar></topbar>
      <navigation></navigation>
      <notifications></notifications>
      <router-view></router-view>
    </div>

    <div v-if="$store.state.unauthorized" style="display: flex; align-items: center; justify-content: center; height: 100vh;">
      <div class="has-text-centered">
        <div class="title is-2 has-text-grey">Unauthorized</div>
        <div>You don't have the required role to view this page.</div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "./modules/admin/partials/Navigation";
import Topbar from "./partials/Topbar";
import Notifications from "./partials/Notifications";

export default {
  components: {
    Navigation,
    Topbar,
    Notifications
  },

  data() {
    return {
      loading: true
    };
  }
};
</script>
